import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BillReadableAttachmentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-bottom: ${Spacing.S32};
`

export const BillImageWrapper = styled.div`
  max-height: 100%;
`

export const BillReadableAttachmentsActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${Spacing.S12};
`

interface AttachmentDropzoneWrapperProps {
  aspectRatio: string
}

export const AttachmentDropzoneWrapper = styled.div<AttachmentDropzoneWrapperProps>`
  display: flex;
  width: 100%;
  aspect-ratio: ${({ aspectRatio }) => aspectRatio};
`
